import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-osu-navbar',
    templateUrl: './osu-navbar.component.html',
    styleUrls: ['./osu-navbar.component.scss'],
    standalone: false
})
export class OsuNavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
